/*****************************
 * UR-ATTACH-ROOT
 *     attach target element
 *****************************/

// 1. Prepare tooltip object :: Global once
export default {
    name : 'ur-attach-root',
    inserted(el, bind, vnode) {

        const context  = vnode.context;
        const directFlag = bind.arg === 'direct' || bind.modifiers.direct;
        const fitFlag    = bind.arg === 'fit'    || bind.modifiers.fit;

        const $anchor = (bind.value ? context.$refs[bind.value] : false) || context.$el
        const $el = el.$el || el;

        let isModal = false;
        let element = $el;
        while(element.parentElement){
            element = element.parentElement;
            if(element.classList.contains("ur-system")){
                break;
            }
            if(element.classList.contains("ur-modal__body")){
                isModal = true;
                break;
            }
        }

        const $root = context.$root.$el || context.$root;
        if($root){
            $root.appendChild($el);
        }

        // 1. Element control
        // 1.1 Hide disply
        const CLOSE_DISPLAY = 'none'
        const OLD_DISPLAY = (!el.style.display || CLOSE_DISPLAY===el.style.display) ? 'block' : el.style.display;
        // 2. Do attach
        // 2.1 Close first
        $el.style.display=CLOSE_DISPLAY;
        // 2.2 Check direct Flag
        if(directFlag) {
            adjustPosition($el, $anchor, OLD_DISPLAY, fitFlag, isModal);
        }
        // 2.3 Append method
        el.open  = () => {
            adjustPosition($el, $anchor, OLD_DISPLAY, fitFlag, isModal)
        }
        el.resize = (e) => {
            adjustPosition($el, $anchor, OLD_DISPLAY, fitFlag, isModal)
        }
        el.isShow = ()=>{
            return (el.style.display === 'block' || CLOSE_DISPLAY!==el.style.display)
        }
        el.close = () => {
            $el.style.display=CLOSE_DISPLAY
        }
    },
    unbind(el,bind,vnode) {
        el.open  = null
        el.close = null
        el.resize = null
    },

}

function adjustPosition($el, $anchor, oldDisplay, fitFlag, modal){
    var rect, pos;
    // 0. Prepare process.
    // 0.1 check anchor & element
    if(!$anchor) {
        $el.style.top=0
        return;
    }
    // 0.2 prepare position info.
    rect = $anchor.getBoundingClientRect();
    var scrWidth  = document.body.clientWidth;
    var scrHeight = document.body.clientHeight;
    // 0.3 It's flag
    var rightFlag = false, bottomFlag = false;
    // 1. calc position & type
    pos = {x:rect.left,y:rect.top+rect.height};
    if(rect.left > scrWidth/2) {
        rightFlag = true;
        pos.x = scrWidth - (pos.x + rect.width);
    }
    if(rect.top > scrHeight/2) {
        bottomFlag = true;
        pos.y = scrHeight - rect.top;
    }
    // 2. make style objct
    if(bottomFlag) {
        $el.style['bottom'] = pos.y+'px';
        $el.style['top']    = 'auto';
    } else {
        $el.style['bottom'] = 'auto';
        $el.style['top']    = pos.y+'px';
    }
    if(rightFlag) {
        $el.style['right'] = pos.x+'px';
        $el.style['left']  = 'auto';
    } else {
        $el.style['right'] = 'auto';
        $el.style['left']  = pos.x+'px';
    }
    
    $el.style['position']  = 'fixed';
    if(oldDisplay) {
        $el.style.display= oldDisplay
    }
    if(fitFlag) {
        $el.style['width'] = rect.width+'px';
    } else {
        $el.style['min-width'] = rect.width+'px';
    }

    if(modal){
        // NOTE: z-index 값은 _urComponentTokens.scss 파일의 $ur-modal__content__z-index 값과 같게 두는 것을 권장합니다.
        // scss 에서 export한 변수로 사용시 IDE에서 scss 중복로드 에러 발생으로 일단 상수값으로 넣어놓습니다.
        // error  : SassError: This file is already being loaded
        $el.style['z-index'] = 3000;
    }
    return;
}